import { createContext } from "react";

/**
 * A host that can widen the docx pane when the review rail needs room, such
 * as the Case IDE hiding its files rail. Without one, the page shrinks to fit
 * beside the rail.
 */
export type DocxReviewRoom = {
  makeRoom: () => void;
  releaseRoom: () => void;
};

export const DocxReviewRoomContext = createContext<DocxReviewRoom | null>(null);
